// src/pages/NotFound.js
import React from "react";
import { Link, useNavigate } from "react-router-dom";

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <div className="page page--center">
      <div className="notfound">
        <div className="notfound__code" aria-hidden="true">404</div>
        <h1 className="notfound__title">Page not found</h1>
        <p className="notfound__sub">
          The page you're looking for doesn't exist or has been moved.
        </p>
        <div className="notfound__actions">
          <button className="btn-outline" onClick={() => navigate(-1)}>
            ← Go Back
          </button>
          <Link to="/" className="btn-primary">Browse Photos</Link>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
